import { createContext } from 'react';

const PageNavigationContext = createContext({
  id: "",
  setId: () => {
  },
  toggleExpand: (_rowId) => null
});

export { PageNavigationContext as default };
//# sourceMappingURL=PageNavigationContext.es.js.map
